import * as React from 'react';
import {
	Box,
	Button,
	CardActionArea,
	CardActions,
	Card,
	CardContent,
	CardMedia,
	IconButton,
	Typography,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { createAdventure } from '../../services/adventuresRequest';

export default function GameCard() {
	const { t, i18n } = useTranslation();

	const defaultCover =
		'//upload.wikimedia.org/wikipedia/commons/thumb/b/be/Role_playing_gamers.jpg/800px-Role_playing_gamers.jpg';

	return (
		<Card sx={{ maxWidth: 345, height: 258 }}>
			<Link
				to="/adventure/new"
				style={{ textDecoration: 'none', color: 'inherit', height: '100%' }}>
				<CardActionArea>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: '195px',
						}}>
						<IconButton sx={{ width: '80px', height: '80px' }}>
							<Add fontSize="large" />
						</IconButton>
					</Box>
					<CardContent>
						<Typography gutterBottom variant="h5" component="div">
							Create new adventure
						</Typography>
					</CardContent>
				</CardActionArea>
			</Link>
		</Card>
	);
}
